import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { isEmpty } from 'lodash';

const useAuth = () => {
  const { isAuthenticated, isValidatingToken, loginUser, impersonatedUser } = useSelector((state) => state.auth);
  let {
    assignedDivisions,
    assignedClients,
    assignedLocations,
    assignedSourceSystems,
    assignedProjects,
    assignedSuppliers,
    assignedContracts,
    assignedFleets,
    assignedScenarios,
    assignedAddressTypes,
    dateFormat,
    dateTimeFormat,
    permissionSet,
    // added for petrohub user
    permissions,
    customPermissions,
    userToRoles,
    userAddressList,
    userContactList,
    isPetroHubUser,
    userGlobalFilterPetroHub,
    // end of petrohub user additions
    username,
    isClientOnHold
  } = loginUser || {};

  const { token } = loginUser || {};
  let { user } = loginUser || {};
  if (impersonatedUser) {
    user = impersonatedUser.user;
  }

  let timezone = user ? user.Timezone : '';

  if (impersonatedUser) {
    assignedDivisions = impersonatedUser.assignedDivisions;
    assignedClients = impersonatedUser.assignedClients;
    assignedLocations = impersonatedUser.assignedLocations;
    assignedSourceSystems = impersonatedUser.assignedSourceSystems;
    assignedProjects = impersonatedUser.assignedProjects;
    assignedSuppliers = impersonatedUser.assignedSuppliers;
    assignedFleets = impersonatedUser.assignedFleets;
    assignedContracts = impersonatedUser.assignedContracts;
    assignedAddressTypes = impersonatedUser.assignedAddressTypes;
    assignedScenarios = impersonatedUser.assignedScenarios;
    dateFormat = impersonatedUser.dateFormat;
    dateTimeFormat = impersonatedUser.dateTimeFormat;
    permissionSet = impersonatedUser.permissionSet;
    permissions = impersonatedUser.permissions;
    userToRoles = impersonatedUser.userToRoles;
    userAddressList = impersonatedUser.userAddressList;
    userContactList = impersonatedUser.userContactList;
    userToRoles = impersonatedUser.userToRoles;
    username = impersonatedUser.Username;
    isClientOnHold = impersonatedUser.isClientOnHold;
    isPetroHubUser = impersonatedUser.isPetroHubUser;
    customPermissions = impersonatedUser.customPermissions;
    userGlobalFilterPetroHub = impersonatedUser.userGlobalFilterPetroHub;

    if (impersonatedUser.user) {
      timezone = impersonatedUser.user.Timezone;
    }

    if (!dateFormat) {
      dateFormat = isPetroHubUser ? 'yyyy/MM/dd' : 'mm-dd-yyyy';
      dateTimeFormat = isPetroHubUser ? 'yyyy/MM/dd HH:mm:ss' : 'mm-dd-yyyy HH:mm:ss';
    }
  }

  const isAuthorized = useCallback(
    ({ permissionCode, right }) => {
      if (!permissionSet || !permissionCode) {
        return false;
      }
      if (isPetroHubUser && isEmpty(permissions)) return false;
      if (isPetroHubUser) {
        const options = permissions.filter(
          (permission) => permission.Code.toLowerCase() === permissionCode.toLowerCase()
        )[0]?.Options;
        // console.log('Options for the permission: ', options);
        // Check if options exist AND include the right (remove the permissionSet check)
        return options && options.includes(right);
      }
      return permissionSet[permissionCode.toLowerCase()];
    },
    [permissionSet, permissions, isPetroHubUser]
  );
  const isAuthorizedForPetroHub = useCallback(
    ({ permissionCode }) => {
      if (!permissionSet || !permissionCode) {
        return false;
      }
      return permissionSet[permissionCode.toLowerCase()];
    },
    [permissionSet]
  );

  return {
    isAuthenticated,
    isValidatingToken,
    user,
    token,
    username,
    permissionSet,
    assignedDivisions,
    assignedFleets,
    assignedContracts,
    assignedClients,
    assignedLocations,
    assignedSourceSystems,
    assignedProjects,
    assignedSuppliers,
    assignedScenarios,
    assignedAddressTypes,
    dateFormat,
    dateTimeFormat,
    timezone,
    isAuthorized,
    isAuthorizedForPetroHub,
    isClientOnHold,
    userAddressList,
    userToRoles,
    userContactList,
    isPetroHubUser,
    userGlobalFilterPetroHub,
    customPermissions
  };
};
export const getUserTimezone = (state) => {
  const { loginUser } = state.auth;
  const timezone = loginUser?.user?.Timezone || '';
  return timezone;
};
export default useAuth;
